import isLogged from '@/helpers/api/isLogged';
window.isAuthenticated = isLogged();

import repositoryFactory from '@/helpers/api/apiFactory';
const api = repositoryFactory('auth');

export default async function (to, from, next) {
    if (to.meta.layout != 'auth' && !isAuthenticated) {
        console.log('order');

        // await api.$axios.refreshToken();

        // if (!isAuthenticated) {
        //     next('/auth/login');
        // }
        // next();
    }

    // if (from.query.access_token) {
    //     document.cookie = `access_token=${from.query.access_token}; max-age=${from.query.expires_in}; path=/;`;
    //     document.cookie = `refresh_token=${from.query.refresh_token}; max-age=${from.query.expires_in}; path=/;`;
    //     document.cookie = `expires_in=${from.query.expires_in}; max-age=${from.query.expires_in}; path=/;`;

    //     console.log(document.cookie, 2)
    //     next();
    // api.$axios.setToken(true, from.query)
    // }
    // console.log(from.query)
    next();
    // }



    // }

}